import React from "react";
import Avatar from "@mui/material/Avatar";
import { UserInfo } from "../users/UserInfo";
import { isBlank } from "../utils";

function stringToColor(s: string) {
  let hash = 0;

  for (let i = 0; i < s.length; i += 1) {
    hash = s.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function initials(name: string) {
  const parts = name.split(/\s+/).filter(Boolean);

  if (parts.length === 0) {
    return "";
  }

  if (parts.length === 1) {
    return parts[0][0]?.toUpperCase() || "";
  }

  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
}

function stringAvatar(name: string) {
  if (isBlank(name)) {
    return {};
  }

  return {
    sx: {
      bgcolor: stringToColor(name),
      width: 30,
      height: 30,
      marginLeft: "4px",
      fontSize: "1rem",
    },
    children: initials(name),
  };
}

export function UserAvatar(user?: UserInfo | null) {
  const firstname = user?.firstname || "";
  const lastname = user?.lastname || "";
  const username = user?.username || "";
  const email = user?.email || "";
  const picture = user?.picture || "";

  const name = !isBlank(firstname)
    ? `${firstname} ${lastname}`.trim()
    : !isBlank(lastname)
      ? lastname
      : !isBlank(username)
        ? username
        : email;

  if (!isBlank(picture)) {
    return (
      <Avatar
        alt={name}
        src={picture}
        sx={{ width: 30, height: 30 }}
      />
    );
  }

  if (!isBlank(name)) {
    return <Avatar {...stringAvatar(name)} />;
  }

  return (
    <Avatar
      src="/assets/public/avatar.png"
      sx={{ width: 30, height: 30 }}
    />
  );
}